import React, { ReactNode } from 'react';
import styled from 'styled-components';

import Box from 'components/Box';
import Text from 'components/Text';
import TabContext from 'containers/TabContext';
import { colors, transition } from 'theme';

const Input = styled.input<{ isTabbing?: boolean }>`
  width: 100%;
  height: 100%;
  margin: 0;
  appearance: none;
  cursor: pointer;
  ${(props) =>
    !props.isTabbing &&
    `
    &:focus {
      outline: 0;
    }
  `}
`;
const Container = styled.div.attrs(({ checked }: { checked?: boolean }) => ({
  style: {
    background: checked ? colors.waterBlue : 'transparent',
    boxShadow: `0 0 0 1px ${checked ? colors.waterBlue : colors.silver} inset`,
    color: checked ? 'white' : colors.charcoalGrey,
  },
}))`
  position: relative;
  display: flex;
  align-items: center;
  padding: 8px 16px;
  height: 100%;
  border-radius: 10px;
  transition: all ${transition};
  &:hover {
    background: ${colors.waterBlue} !important;
    color: white !important;
    box-shadow: 0 0 0 1px ${colors.waterBlue} inset !important;
  }

  input[type='radio'] {
    border-radius: 10px;
  }
`;

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const SquareRadioButton = ({
  id,
  name,
  value,
  label,
  checked,
  onChange,
  hideRadioButtons,
  ...props
}: {
  'data-qa-id'?: string;
  id?: string;
  name?: string;
  value: string | boolean | number;
  label: ReactNode;
  checked: boolean;
  onChange?: (
    arg0:
      | (string | null | undefined)
      | (boolean | null | undefined)
      | (number | null | undefined)
  ) => void;
  onClick?: () => void;
  alignTop?: boolean;
  hideRadioButtons?: boolean;
  disabled?: boolean;
}) => (
  // @ts-expect-error Fix types
  <Container checked={checked}>
    <Box top={0} left={0} position="absolute" width={1} height="100%">
      <TabContext.Consumer>
        {(isTabbing) => (
          <Input
            type="radio"
            name={name}
            id={id}
            checked={checked}
            value={typeof value === 'string' ? value : value.toString()}
            onChange={(e) => {
              e.stopPropagation();

              if (onChange) {
                onChange(value);
              }
            }}
            isTabbing={isTabbing}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...props}
          />
        )}
      </TabContext.Consumer>
    </Box>
    <Box htmlFor={id} as="label">
      <Text styleAs="h4">{label}</Text>
    </Box>
  </Container>
);

export default SquareRadioButton;
